import Store from './Store';
import * as React from 'react';
import Heading from './Heading';
import Programs from './Programs';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import Competencies from './Competencies';
import SchoolPartners from './SchoolPartners';
import { LearningDesignResource } from '../../../../../../../../../../Types';
import { emptyFragment } from '../../../../../../../../../../../../EmptyFragment';

export interface Props {
  resource: LearningDesignResource;
}

class Content extends React.Component<Props> {
  contentStore: Store = new Store('programs', this.props.resource);

  render() {
    return (
      <div className="max-h-[70vh] overflow-x-hidden">
        <div>
          <Heading store={this.contentStore} />
          {fromEmpty(this.props.resource.payload.experiences)
            .map(() => <Programs store={this.contentStore} />)
            .getOrElse(emptyFragment)}
          {fromEmpty(this.props.resource.payload.schoolPartners)
            .map(() => <SchoolPartners store={this.contentStore} />)
            .getOrElse(emptyFragment)}
          {fromEmpty(this.props.resource.payload.competencies)
            .map(() => <Competencies store={this.contentStore} />)
            .getOrElse(emptyFragment)}
        </div>
      </div>
    );
  }
}

export default observer(Content);
